import Store from '@/store'

export default {
  computed: {
      crmData () {
        const FIO =
        Store.state.user.personal.surname + ' ' +
        Store.state.user.personal.name
    
      const description = `
ПІБ ${FIO}
Телефон ${Store.state.user.phone}
Email ${Store.state.user.email}
Дата народження ${Store.state.user.personal.birthday}
Сімейний стан ${Store.state.user.personal.family_status}
_____
      `

      return {
        name: FIO,
        account: 'Multiplex. Особистий кабінет',
        phone: Store.state.user.phone,
        email: Store.state.user.email,
        subject: 'Видалення облікового запису',
        symptoms: description
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/profile-page/impl/delete-account/imlp/data-for-crm/script.js